function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTalentNetworkHighScore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.349,
    height: 56,
    viewBox: "0 0 56.349 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h56v56H0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M521.539 104.146a5.7 5.7 0 1 1 5.7-5.7 5.7 5.7 0 0 1-5.7 5.7m-16.863-8.066c.1.271.212.628.344 1.042a23.336 23.336 0 0 0 4.119 8.228 14.369 14.369 0 0 0 5.2 3.926v12.92a.959.959 0 0 0 .959.959h11.513a.959.959 0 0 0 .959-.959v-5.277a.48.48 0 0 1 .959 0h0v5.277a2.4 2.4 0 1 0 4.8 0v-5.277a10.535 10.535 0 0 0-3.643-8.121 12.733 12.733 0 0 0-8.35-2.912c-8.019 0-10.372-5.275-11.948-10.22-.148-.463-.275-.864-.407-1.226a2.4 2.4 0 0 0-4.508 1.641",
    transform: "translate(-478.182 -80.022)",
    style: {
      stroke: "#000072",
      strokeLinecap: "round",
      strokeWidth: 2,
      fill: "#ff0660"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3 98.449a5.7 5.7 0 1 1 5.7 5.7 5.7 5.7 0 0 1-5.7-5.7m21.126-5.444a2.4 2.4 0 0 0-3.074 1.433c-.132.362-.259.762-.407 1.226-1.576 4.945-3.929 10.22-11.948 10.22a12.733 12.733 0 0 0-8.35 2.912A10.535 10.535 0 0 0 0 116.918v5.277a2.4 2.4 0 1 0 4.8 0v-5.277h0a.48.48 0 0 1 .959 0v5.277a.959.959 0 0 0 .959.959h11.511a.959.959 0 0 0 .959-.959v-12.92a14.369 14.369 0 0 0 5.2-3.926 23.337 23.337 0 0 0 4.119-8.228c.132-.414.246-.771.344-1.042a2.4 2.4 0 0 0-1.433-3.074",
    transform: "translate(2.147 -80.022)",
    style: {
      fill: "#ffe5ef",
      stroke: "#000072",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.165 3.952a.62.62 0 0 1-.62-.62V.62a.62.62 0 1 1 1.24 0v2.712a.62.62 0 0 1-.62.62",
    transform: "translate(-517.006 5.93)",
    style: {
      fill: "#ff0660"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.826 51.205a.618.618 0 0 1-.4-.145l-2.077-1.743a.62.62 0 0 1 .8-.95l2.077 1.743a.62.62 0 0 1-.4 1.095",
    transform: "translate(-419.999 -39.303)",
    style: {
      fill: "#ff0660"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.065 51.206a.62.62 0 0 1-.4-1.095l2.077-1.743a.62.62 0 0 1 .8.95l-2.077 1.743a.617.617 0 0 1-.4.145",
    transform: "translate(-582.572 -39.304)",
    style: {
      fill: "#ff0660"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentNetworkHighScore);
export default __webpack_public_path__ + "static/media/talent-network-high-score.9b5733a6.svg";
export { ForwardRef as ReactComponent };